import { render, staticRenderFns } from "./ReviewsCategoriesLineChart.vue?vue&type=template&id=823953a8&"
import script from "./ReviewsCategoriesLineChart.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports